import { hasArrayElements } from "@/apiUtils/commonUtils";
import { HeroBannerCTAData } from "@/common/lib/types";
import { constructUrl } from "@/utils/common";
import Button from "../ui/button/Button";
import { CLink } from "./customLink/CustomLink";

interface CTAProps {
  locale: string;
  content?: HeroBannerCTAData;
}
const CtaWidget = ({ locale, content }: CTAProps) => {
  return (
    <div
      className={`absolute bottom-0 left-0 right-0 mx-auto max-w-full translate-y-0 pb-8 md:bottom-auto md:top-2/3 md:max-w-[calc(100%-60px)] md:translate-y-[-66%] md:bg-transparent md:px-0 md:py-0`}
    >
      <div
        className={`flex w-full justify-center gap-4 md:w-2/3 lg:w-2/5 ${content?.ctaAlignment === "right" ? "md:ml-auto" : ""} `}
      >
        {hasArrayElements(content?.items as any[]) &&
          content?.items?.slice(0, 2).map((item) => (
            <CLink
              key={item?.key}
              href={constructUrl(item?.link, locale)}
              target={item?.link?.type === "external" ? "_blank" : ""}
            >
              <Button
                variant="contained"
                className={`${content?.items.length === 1 ? "min-w-[170px]" : "min-w-[122px]"} flex h-10 w-full  max-w-[170px] md:min-w-[170px] items-center justify-center whitespace-nowrap border-white bg-white text-sm font-semibold text-black md:h-[50px]`}
                style={{
                  background: item?.backgroundColor,
                  borderColor: item?.backgroundColor,
                  color: item?.color,
                  fontFamily: content?.fontFace,
                }}
              >
                {item?.title}
              </Button>
            </CLink>
          ))}
      </div>
    </div>
  );
};

export default CtaWidget;
